__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "contrast-ui";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@contrast-security-inc/design-system-alerts", "0.6.3", function() { return Promise.all([__webpack_require__.e(461), __webpack_require__.e(466), __webpack_require__.e(690), __webpack_require__.e(173)]).then(function() { return function() { return __webpack_require__(10466); }; }); });
			register("@contrast-security-inc/design-system-foundations", "3.13.0", function() { return Promise.all([__webpack_require__.e(384), __webpack_require__.e(786), __webpack_require__.e(690)]).then(function() { return function() { return __webpack_require__(39011); }; }); });
			register("@emotion/css", "11.11.2", function() { return Promise.all([__webpack_require__.e(211), __webpack_require__.e(592)]).then(function() { return function() { return __webpack_require__(18592); }; }); });
			register("react-dom", "18.2.0", function() { return function() { return __webpack_require__(73935); }; }, 1);
			register("react-hook-form", "7.32.2", function() { return __webpack_require__.e(536).then(function() { return function() { return __webpack_require__(87536); }; }); });
			register("react-hook-form", "7.45.2", function() { return __webpack_require__.e(770).then(function() { return function() { return __webpack_require__(16770); }; }); });
			register("react-query", "3.39.2", function() { return function() { return __webpack_require__(23724); }; }, 1);
			register("react-router-dom", "6.21.2", function() { return function() { return __webpack_require__(5660); }; }, 1);
			register("react", "18.2.0", function() { return function() { return __webpack_require__(67294); }; }, 1);
			initExternal(40003);
			initExternal(62682);
			initExternal(59247);
			initExternal(58524);
			initExternal(45605);
			initExternal(44053);
			initExternal(40066);
			initExternal(87788);
			initExternal(74285);
			initExternal(72409);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};